var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCompanyTeam(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0h24v24H1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#475B7F",
    d: "M18.5 12c1.823 0 3.3-1.44 3.3-3.214 0-1.775-1.477-3.215-3.3-3.215-1.823 0-3.3 1.44-3.3 3.215S16.677 12 18.5 12zm1.65 1.071h-.13c-.478.161-.984.268-1.52.268s-1.042-.107-1.52-.268h-.13c-.701 0-1.348.198-1.915.516.84.88 1.365 2.05 1.365 3.342v1.285c0 .074-.017.144-.02.215h6.07c.911 0 1.65-.72 1.65-1.608.001-2.07-1.72-3.749-3.846-3.75h-.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F9BB3",
    d: "M8.6 12c2.126 0 3.85-1.679 3.85-3.75 0-2.071-1.724-3.75-3.85-3.75-2.126 0-3.85 1.679-3.85 3.75C4.749 10.32 6.47 12 8.596 12H8.6zm2.64 1.071h-.285a5.52 5.52 0 01-2.355.536 5.53 5.53 0 01-2.355-.536H5.96C3.773 13.072 2 14.8 2 16.93v.964c0 .886.739 1.606 1.65 1.606h9.9c.911 0 1.65-.72 1.65-1.607v-.964c0-2.13-1.772-3.856-3.959-3.858h-.001z"
  }))));
}

export default SvgCompanyTeam;